import moment from 'moment'

import ApiObject from '../ApiObject'

import DateUtils from '../../utils/DateUtils'

export default class AvailabilityDate extends ApiObject {

  fromDate = null

  toDate = null

  postJsonAssignation(data) {
    super.postJsonAssignation(data)

    this.fromDate = moment(data.fromDate)
    this.toDate = moment(data.toDate)
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/menu/AvailabilityDate.js